import React, { useState, useEffect } from "react";
import Head from "next/head";
import HeaderSlim from "~/components/HeaderSlim";
import MultiSelectFormProvider from "~/contexts/MultiSelectForm";

import BookForm from "~/components/confort/Book/Form";

import "bootstrap/dist/css/bootstrap-grid.min.css";
import "bootstrap/dist/css/bootstrap-utilities.min.css";

const GOOGLE_MAPS_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY;

const Book = ({ category, utmSource, returnStep }) => {
    const [utmSourceState, setUtmSourceState] = useState();
    const [currentStep, setCurrentStep] = useState(1);

    useEffect(() => {
        const utm = window.sessionStorage.getItem("utm_source") || utmSource;
        setUtmSourceState(utm);

        const confirmationStep = localStorage.getItem("confirmation");
        if (confirmationStep) {
            setCurrentStep(Number(confirmationStep));
        }
    }, []);

    return (
        <MultiSelectFormProvider>
            <Head>
                <script src={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_KEY}&libraries=places`} />
                <title>Orçamento de fotógrafo profissional - Fotop Serviços</title>
            </Head>
            <HeaderSlim />

            <div className="main" style={{ paddingTop: "1.5rem" }}>
                <BookForm currentStep={currentStep} setCurrentStep={setCurrentStep} utmSource={utmSourceState} />
            </div>
        </MultiSelectFormProvider>
    );
};

Book.getInitialProps = ({ query }) => ({
    category: Number(query.c),
    returnStep: Number(query.returnStep),
    utmSource: query.utm_source,
});

export default Book;
